/* eslint-disable react/require-default-props */
/* eslint-disable react/prop-types */
/*
<Project Name> Component
SelectPaymentAccount
*/
import React, { useRef, useEffect } from 'react';
import './BannerNotification.scss';
import { Notification, NotificationsGroup } from '@vwfs-bronson/bronson-react';

interface BannerNotificationProps {
  notificationStyle?: 'info' | 'success' | 'warning' | 'error';
  children?: React.ReactNode;
  closeIcon?: boolean;
  title?: string;
  isOpen?: boolean;
  closeAction?: () => void;
  className?: string;
  'data-marketing-theme'?: 1 | 2;
}

const BannerNotification: React.FC<BannerNotificationProps> = (props): React.JSX.Element | null => {
  const {
    notificationStyle,
    children = '',
    title = '',
    closeIcon = undefined,
    isOpen = true,
    closeAction = () => null,
    className = '',
  } = props;
  const targetRef = useRef<HTMLDivElement>();
  useEffect(() => {
    // eslint-disable-next-line no-unused-expressions
    const currentTarget = targetRef.current as HTMLDivElement;
    currentTarget?.focus();
  }, []);
  if (!isOpen) return null;
  const closeBanner = () => {
    if (typeof closeAction === 'function') {
      closeAction();
    }
  };
  // eslint-disable-next-line react/destructuring-assignment
  const dataMarketingTheme = props['data-marketing-theme'];
  return (
    <NotificationsGroup className={className}>
      <Notification
        status={notificationStyle}
        title={title}
        visible={isOpen}
        onCloseClick={closeBanner}
        showCloseButton={Boolean(closeIcon)}
        data-testid={`banner-notification-${notificationStyle}`}
        id={`banner-notification-${notificationStyle}`}
        data-marketing-theme={dataMarketingTheme}
      >
        {children}
      </Notification>
    </NotificationsGroup>
  );
};

export default BannerNotification;
